import { Injectable } from '@angular/core';
import { DeviceInt, SaleInt } from '@interfaces/*';
import { Observable, BehaviorSubject } from 'rxjs';
import { CussService } from '@services/cuss.service';
import { Device, deviceIds, TraceLevels } from 'src/embross-device-manager';
import { getDataOperation, xml2json } from '@cuss/embross/utils/helper';
import { PaymentBrand, PaymentSimulationScenario } from '@interfaces/payment-simulation.interface';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class PaymentDeviceService implements DeviceInt {
  device: Device;
  listen$: BehaviorSubject<any> = new BehaviorSubject(null);
  errorTypes: Array<string> = ['DECLINED', 'FAILURE', 'CANCEL', 'UNKNOW', 'UNKNOWN'];
  isComplete = false;
  constructor(private cussServ: CussService) {
    if (cussServ.getDeviceManager()) {
      this.device = cussServ.getDeviceManager().getDevice(deviceIds.PAYMENT);
    }
  }
  enable(name: string, pnr: string, amount: string): void {
    if (this.device) {
      this.device.OnDeviceEvent = this.callback;
      this.device.enable();
      this.setAmount(name, this.cussServ.KioskID, pnr, amount);
    }
  }

  disable(): void {
    this.device.OnDeviceEvent = null;
    this.device.disable();
  }

  startTransactionDummy(
    total: number,
    brand: PaymentBrand = 'VISA',
    scenario: PaymentSimulationScenario = 'success'
  ) {
    const today = new Date();
    const dateOp = today.toISOString();
    let dateReference = dateOp.replace(/[T:]/g, '');
    dateReference = dateOp.replace(/[/]/g, '-');

    // Configuración de marcas de tarjeta
    const brandConfig = {
      VISA: {
        CBRAND: 'visa',
        CARD: '444433******1111',
        APPNM: 'VISA DEBIT',
      },
      AMEX: {
        CBRAND: 'amex',
        CARD: '371449******0911',
        APPNM: 'AMERICAN EXPRESS',
      },
      MC: {
        CBRAND: 'mastercard',
        CARD: '555555******4444',
        APPNM: 'MASTERCARD',
      },
    } as const;

    const selectedBrand = brandConfig[brand] || brandConfig.VISA;

    const SALE: SaleInt = {
      SALE: {
        CMDRES: '',
        TRXDESC: '',
        ACQNAME: 'BANCO SIMULADOR',
        MNAME: 'AEROMEXICO KIOSK',
        MADDR: 'AEROPUERTO INTERNACIONAL',
        IDMER: '87628471',
        CBRAND: selectedBrand.CBRAND,
        TAMNT: '' + total,
        TCCODE: 'MXN',
        TCSYMB: '$',
        TDATE: today.toLocaleDateString('es-MX'),
        THOUR: today.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }),
        TAUT: '',
        CARD: selectedBrand.CARD,
        CENTRY: 'CHIP',
        CINSTR: 'CONTACTLESS',
        CARQC: '00',
        CCVM: 'PIN',
        TREF: '' + this.getRandomInt(100000000000, 999999999999),
        TPMODE: 'CHIP',
        APPNM: selectedBrand.APPNM,
        SNDEV: 'SIMULATOR-001',
        dateOperation: dateReference,
        CAID: 'A0000000031010',
      },
    };

    // Configurar respuesta según el escenario
    switch (scenario) {
      case 'success':
        SALE.SALE.TAUT = '' + this.getRandomInt(100000, 999999);
        SALE.SALE.CMDRES = 'APPROVED';
        SALE.SALE.TRXDESC = 'TRANSACCION APROBADA';
        break;

      case 'declined':
        SALE.SALE.TAUT = '';
        SALE.SALE.CMDRES = 'DECLINED';
        SALE.SALE.TRXDESC = 'TRANSACCION RECHAZADA';
        break;

      case 'timeout':
        SALE.SALE.TAUT = '';
        SALE.SALE.CMDRES = 'TIMEOUT';
        SALE.SALE.TRXDESC = 'TIEMPO DE ESPERA AGOTADO';
        break;

      case 'insufficient_funds':
        SALE.SALE.TAUT = '';
        SALE.SALE.CMDRES = 'INSUFFICIENT_FUNDS';
        SALE.SALE.TRXDESC = 'FONDOS INSUFICIENTES';
        break;

      case 'invalid_card':
        SALE.SALE.TAUT = '';
        SALE.SALE.CMDRES = 'INVALID_CARD';
        SALE.SALE.TRXDESC = 'TARJETA INVALIDA';
        SALE.SALE.CARD = '000000******0000';
        break;

      case 'network_error':
        SALE.SALE.TAUT = '';
        SALE.SALE.CMDRES = 'NETWORK_ERROR';
        SALE.SALE.TRXDESC = 'ERROR DE COMUNICACION';
        break;

      case 'use_pinpad':
        SALE.SALE.TAUT = '';
        SALE.SALE.CMDRES = 'USE_PINPAD';
        SALE.SALE.TRXDESC = 'ENTRADA MANUAL EN PINPAD';
        break;

      default:
        // Por defecto: success
        SALE.SALE.TAUT = '' + this.getRandomInt(100000, 999999);
        SALE.SALE.CMDRES = 'APPROVED';
        SALE.SALE.TRXDESC = 'TRANSACCION APROBADA';
    }

    return SALE.SALE;
  }
  isOK(): boolean {
    return this.device.isDeviceOk && this.device.deviceStatus != 305;
  }

  startTransaction(): void {
    if (!this.device) {
      console.warn(
        '[PaymentDeviceService] startTransaction omitido: dispositivo PAYMENT no disponible'
      );
      return;
    }
    this.device.startTransaction();
  }
  getTransactionResult() {
    this.device.getTransactionResult();
  }
  cancelTransaction() {
    this.device.cancelTransaction();
  }
  clearTransactionData() {
    console.log('[PAYMENT]-->[Clear_TransactionData]');
    this.device.clearTransactionData();
  }

  callback = (event: any) => {
    if (!environment.production) {
      // eslint-disable-next-line no-console
      console.warn('[PAYMENT] Event:', event.key);
    }
    switch (event.key) {
      case 'stateChanged':
        console.log(TraceLevels.LOG_EXT_TRACE, 'Event:  stateChanged', event.value);
        switch (event.value) {
          // when device is offline
          case 'STATE_UNAVAILABLE':
            console.log(TraceLevels.LOG_TRACE, 'Event: STATE_UNAVAILABLE is received');
            break;
          // when device is initially initializing
          case 'STATE_INITIALIZING':
            console.log(TraceLevels.LOG_TRACE, 'Event: STATE_INITIALIZING is received');
            break;
          // when the device is expecting user interaction and waiting for the amount to be charged to the customer
          case 'STATE_WAITING':
            console.log(TraceLevels.LOG_TRACE, 'Event: STATE_WAITING is received');
            break;
          // when the amount has been set by the application
          case 'STATE_READY, STATE_WAITING':
            console.log(
              TraceLevels.LOG_TRACE,
              'Event: STATE_READY, STATE_WAITING is received enable buttons'
            );
            this.listen$.next({ event, action: 'startTransaction' });
            break;
          case 'STATE_WAITING, STATE_PENDING':
            console.log(TraceLevels.LOG_TRACE, 'Event: STATE_WAITING, STATE_PENDING is received');
            break;
          case 'STATE_PENDING, STATE_READY':
            console.log(TraceLevels.LOG_TRACE, 'Event: STATE_PENDING, STATE_READY is received');
            break;
          case 'STATE_PENDING':
            console.log(TraceLevels.LOG_TRACE, 'Event: STATE_PENDING is received');
            break;
          case 'STATE_SUCCESS':
          case 'STATE_FAILURE, STATE_PENDING':
          case 'STATE_FAILURE':
          case 'STATE_SUCCESS, STATE_PENDING':
            console.log(TraceLevels.LOG_TRACE, 'Event: STATE_FAILURE is received');
            this.listen$.next({ event, action: 'getTransactionResult' });
            break;
          default:
        }
        break;
      case 'getTransactionResult': {
        console.log(TraceLevels.LOG_TRACE, 'Event: TRANSACTION_RESULT_IS_RECEIVED:', event.value);
        const xmlResponse = event.value;
        const response: {
          success: boolean;
          approved: unknown;
          message: string | null;
        } = {
          success: true,
          approved: null,
          message: null,
        };
        const { SALE } = getDataOperation(xmlResponse) as SaleInt;
        if (!environment.production) {
          // eslint-disable-next-line no-console
          console.log('[SALE]', SALE?.CMDRES);
        }

        const xmlNode = new DOMParser().parseFromString(xmlResponse, 'text/xml');
        const dataRead = JSON.parse(xml2json(xmlNode));
        if (!environment.production) {
          // eslint-disable-next-line no-console
          console.log('[Data_Read_JSON] PaymentResult:', dataRead?.PaymentResponse?.PaymentResult);
        }
        const { PaymentResponse } = dataRead;
        if (PaymentResponse && PaymentResponse.PaymentResult) {
          response.success = !this.errorTypes.includes(PaymentResponse.PaymentResult);
        }

        if (response.success && SALE) {
          if (!environment.production) {
            // eslint-disable-next-line no-console
            console.log('[PAYMENT] Transaction approved');
          }
          SALE.TDATE = SALE.TDATE.replace(/[/]/g, '-');
          SALE.THOUR = SALE.THOUR.replace(/[:]/g, '');
          SALE.dateOperation = `${SALE.TDATE} ${SALE.THOUR}`;
          response.approved = SALE;
          const paymentApproved = { event, action: 'approved', data: response.approved };
          this.listen$.next(paymentApproved);
        } else {
          if (!environment.production) {
            // eslint-disable-next-line no-console
            console.log('[PAYMENT] Transaction declined/failure:', response.message);
          }
          response.message = PaymentResponse.PaymentResult;
          this.listen$.error(response);
        }

        setTimeout(() => {
          this.listen$.complete();
          this.isComplete = true;
        }, 3000);
        break;
      }
      case 'keyPressed':
        console.log(TraceLevels.LOG_EXT_TRACE, 'Event:  keyPressed', event.value);
        break;
      case 'messageChanged':
        console.log(TraceLevels.LOG_EXT_TRACE, 'Event:  messageChanged', JSON.stringify(event));
        break;
      default:
        console.log(TraceLevels.LOG_EXT_TRACE, 'Other payment Event: ' + event.key);
    }
  };

  listen(): Observable<any> {
    if (this.isComplete) {
      this.listen$ = new BehaviorSubject(null);
    }
    return this.listen$.asObservable();
  }

  setAmount = (name, KioskID, PNR, amount) => {
    const reference = this.getReference(name, KioskID, PNR);
    if (!environment.production) {
      // eslint-disable-next-line no-console
      console.log('[PAYMENT_AMOUNT]', reference, amount);
    }

    this.device.set('OPCODE', reference.substring(0, 27));
    this.device.set('AMOUNT', amount);
  };

  getReference = (name: string, KioskID: string, pnr: string) => {
    const nameLen = name?.length;
    const nameOwner =
      name && name.length > 0 ? name.substring(0, nameLen > 10 ? 10 : nameLen).toUpperCase() : '';
    const today = new Date();
    const format = today.toISOString();
    const dateReference = format.replace(/[-:T]/g, '');
    const dateSplit = dateReference.split('.');
    const sanitizeKiosk = KioskID.replace(/[-\\/:]/g, '');
    const KioskLen = sanitizeKiosk.length;

    const KioskIDSub = sanitizeKiosk.substring(0, KioskLen > 10 ? 10 : KioskLen);
    return `${nameOwner}${KioskIDSub}${pnr}${dateSplit[0]}`;
  };

  getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min);
  }
}
